import axios from "axios";
import { isAuthenticated, logout } from "./auth";
import constants from "../../constants";


const api = async (
  method,
  endPoint,
  data = {},
  params = {},
  extraHeaders = {}
) => {
  try {
    let headers = {
      "Content-Type": "application/json",
      ...extraHeaders,
    };
    if (isAuthenticated()) {
      headers = {
        ...headers,
        Authorization: `Bearer ${isAuthenticated()}`,
      };
    }

    let response = await axios({
      method,
      url: constants.endPointUrl + endPoint,
      data,
      headers,
      params,
    });

    let res = response.data;

    return res;
  } catch (error) {
    if (error?.response?.status === 401) {
      logout();
    }
    let res = error?.response ? error.response.data : error.toString();
    return res;
  }
};

export default api;
